import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.to-string-f55666a8.js";
import { useState as x, useEffect as R } from "react";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./array-method-is-strict-e5a3c878.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./function-uncurry-this-clause-99074d1c.js";
var a = {
  tabIndex: "tabIndex",
  title: "title",
  ariaLabel: "aria-label",
  ariaLabelledBy: "aria-labelledby",
  ariaSelected: "aria-selected",
  ariaDescribedBy: "aria-describedby",
  ariaHidden: "aria-hidden",
  ariaDisabled: "aria-disabled",
  ariaPressed: "aria-pressed",
  ariaExpanded: "aria-expanded",
  ariaHasPopup: "aria-haspopup",
  ariaControls: "aria-controls",
  ariaChecked: "aria-checked",
  ariaMultiselectable: "aria-multiselectable",
  ariaActivedescendant: "aria-activedescendant",
  ariaInvalid: "aria-invalid",
  ariaRequired: "aria-required",
  ariaPlaceholder: "aria-placeholder",
  ariaMultiline: "aria-multiline",
  ariaReadOnly: "aria-readonly",
  ariaAutoComplete: "aria-autocomplete",
  ariaActiveDescendant: "aria-activedescendant",
  ariaOwns: "aria-owns",
  ariaValuMin: "aria-valuemin",
  ariaValuMax: "aria-valuemax",
  ariaValuText: "aria-valuetext",
  ariaValuenow: "aria-valuenow",
  ariaLive: "aria-live",
  ariaBusy: "aria-busy",
  ariaModal: "aria-modal",
  ariaVisited: "aria-visited",
  target: "target",
  rel: "rel",
  ariaAtomic: "aria-atomic"
}, S = a.tabIndex, b = a.ariaChecked, H = a.ariaDisabled, d = a.ariaSelected, T = a.ariaLabel, E = a.ariaLabelledBy, q = a.ariaDescribedBy, _ = a.ariaHidden, N = a.ariaPressed, p = a.ariaExpanded, O = a.ariaHasPopup, o = a.ariaControls, P = a.ariaMultiselectable, u = a.ariaInvalid, j = a.ariaRequired, $ = a.ariaPlaceholder, G = a.ariaMultiLine, U = a.ariaReadOnly, z = a.ariaAutoComplete, F = a.ariaActiveDescendant, J = a.ariaOwns, y = a.ariaValuMin, h = a.ariaValuMax, I = a.ariaValuText, B = a.ariaValuenow, A = a.ariaLive, M = a.ariaBusy, K = a.ariaModal, Q = a.ariaVisited, W = a.target, X = a.rel, Y = a.ariaAtomic, t = [T, E, q, _, H, S], Z = [].concat(t, [A, Y]), aa = [].concat(t, [N, p, O, o]), ia = [].concat(t, [y, h, I, B, A, M]), ra = [].concat(t, [y, h, I, B, A, M]), ta = [].concat(t), ea = [].concat(t, [b]), sa = [].concat(t, [b]), na = [].concat(t, [b, u]), ca = [].concat(t), oa = [].concat(t, [P]), ua = [].concat(t, [d]), la = [].concat(t, [K]), ba = [].concat(t, [P, p, u, j, o]), da = [].concat(t, [j, $, u, U, G, z, o, p, O, F, J]), pa = [].concat(t, [u]), Aa = [].concat(t, [Q, d, W, X]), va = [].concat(t, [d, o]), ma = [].concat(t), ga = {
  alert: Z,
  button: aa,
  switch: ea,
  region: ta,
  listitem: ca,
  listbox: oa,
  option: ua,
  input: da,
  progressbar: ia,
  dialog: la,
  checkbox: sa,
  radio: na,
  radiogroup: pa,
  combobox: ba,
  link: Aa,
  tab: va,
  tabpanel: ma,
  slider: ra
}, Ta = function(i, e, s) {
  var v = x(!1), V = v[0], f = v[1], m = x(!1), L = m[0], k = m[1];
  R(function() {
    var c, n;
    i === "button" && (s == null || (c = s.current) == null ? void 0 : c.tagName) === "BUTTON" && f(!0), i === "button" && (s == null || (n = s.current) == null ? void 0 : n.tagName) === "A" && k(!0);
  }, [s, i]);
  var w = function(n, C) {
    var g = {};
    return Object.keys(n).forEach(function(l) {
      C.includes(a[l]) && (g[a[l]] = n[l]);
    }), g;
  }, r = w(e, ga[i]), D = function() {
    switch (i) {
      case "alert":
        return Object.assign({
          role: i
        }, r);
      case "button":
        return Object.assign({}, !V && {
          role: L ? "link" : i,
          tabIndex: (e == null ? void 0 : e.tabIndex) || 0
        }, r);
      case "input":
        return Object.assign({}, r);
      case "progressbar":
        return Object.assign({
          role: i
        }, r);
      case "region":
        return Object.assign({
          role: i
        }, r);
      case "switch":
        return Object.assign({
          role: i,
          tabIndex: e.tabIndex || 0
        }, r);
      case "listbox":
        return Object.assign({
          role: i
        }, r);
      case "option":
        return Object.assign({
          role: i
        }, r);
      case "dialog":
        return Object.assign({
          role: i
        }, r);
      case "listitem":
        return Object.assign({}, r);
      case "checkbox":
        return Object.assign({
          role: i,
          tabIndex: e.tabIndex || 0
        }, r);
      case "radio":
        return Object.assign({
          role: i
        }, r);
      case "radiogroup":
        return Object.assign({
          role: i
        }, r);
      case "combobox":
        return Object.assign({
          role: i
        }, r);
      case "link":
        return Object.assign({
          role: i
        }, r);
      case "tab":
        return Object.assign({
          role: i
        }, r);
      case "tabpanel":
        return Object.assign({
          role: i
        }, r);
      case "slider":
        return Object.assign({
          role: i
        }, r);
      default:
        return {};
    }
  };
  return D();
};
export {
  Ta as useAccessibilityProps
};
